export default __webpack_public_path__ + "static/media/Best Oral Presenters of 1st WCHSS.c199b963.JPG";